class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.container = document.getElementById('CartDrawer');
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }
  updateProgressBar() {
    const progres_section = this.container.querySelector('.cart-progress-bar');
    if (progres_section) {
      let totalCents = parseInt(progres_section.dataset.cartTotal); // Total in cents (e.g., 7497)
      let total = totalCents / 100; // Convert to dollars (e.g., 74.97)
  
      const progressSteps = document.querySelectorAll(".progress-step");
      const progressBar = document.querySelector(".progress-bar");
      const amountAway = document.getElementById("amount-away");
      const amountAwayPercent = document.getElementById("amount-away_percent");
      const final_mesage = document.getElementById("final_message_progress_bar");
      const initial_message = document.querySelectorAll(".initial_message");
  
      // Reset progress steps
      progressSteps.forEach((step) => step.classList.remove("completed", "active"));
  
      let nextThreshold = null;
      let nextDiscount = null;
  
      // Iterate through thresholds to find the next unmet one
      progressSteps.forEach((step) => {
      
        const thresholdCents = parseInt(step.dataset.threshold); // Threshold in cents (e.g., 7500)
        const threshold = thresholdCents / 100; // Convert to dollars (e.g., 75.00)
        const discountText = step.querySelector(".message_tresholds").innerText; // Discount text
  
        // If total exceeds or equals the threshold
        if (total >= threshold) {
          step.classList.add("completed");
        } else if (!nextThreshold) {
          // This is the next unmet threshold
          step.classList.add("active");
          nextThreshold = threshold;
          nextDiscount = discountText.match(/\d+%/)[0]; // Extract discount percentage
        }
      });
  
      // Update the amount-away and amount-away_percent text
      if (nextThreshold && nextDiscount) {
        const amountRemaining = (nextThreshold - total).toFixed(2); // Calculate the difference
        amountAway.textContent = `$${amountRemaining}`;
        amountAwayPercent.textContent = `${nextDiscount} off`;
      } else {
        // If all thresholds are met, show a "Max discount reached" message (optional)
        amountAway.textContent = "$0.00";
        amountAwayPercent.textContent = "Maximum discount reached";
        final_mesage.style.display = "block";
        initial_message.forEach((msg) => msg.style.display = "none");
      }
  
      // Calculate progress percentage relative to the highest threshold
      const thresholds = Array.from(progressSteps).map((step) => parseInt(step.dataset.threshold) / 100); // Normalize thresholds
      const maxThreshold = Math.max(...thresholds); // Get the highest threshold
      const progressPercentage = Math.min((total / 100) * 100, 100);
  
      // Update progress bar width
      progressBar.style.setProperty("--progress-width", `${progressPercentage}%`);
    }
   
  }
  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
